import React, { useEffect, useState } from "react";
import Header from "components/Headers/Header";
import {
  Container,
  Table,
  Button,
  Card,
  Row,
  Col,
  Badge,
  UncontrolledPopover,
  PopoverBody,
} from "reactstrap";
import { Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getResolutions } from "store/actions/resolutionAction";
import moment from "moment";
import TableComponent from "components/TableComponent";
import TabsInfoModal from "components/Modal/TabsInfoModal";

function truncateText(text, maxLength) {
  if (text?.length <= maxLength) {
    return text;
  } else {
    const truncatedText = text?.substr(0, maxLength);
    return `${truncatedText}...`;
  }
}

const Resolution = () => {
  const dispatch = useDispatch();

  const {
    resolutions,
    isLoading,
    hasMoreResolutions,
    isFetchingResolutions,
    lastDoc,
  } = useSelector((state) => state.resolution);
  const [loader, setLoader] = useState({
    data: false,
  });

  const [selectedResolution, setSelectedResolution] = useState(null);

  const infoPoints = [
    "Fans and athletes can raise resolutions, which the admin reviews and communicates with them to address. The final decision to resolve the issue rests with the admin.",
  ];
  const subPoints = [];
  const infoTitle = "Resolution Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  const handleLoadMore = () => {
    if (hasMoreResolutions && !isFetchingResolutions) {
      dispatch(getResolutions(lastDoc));
    }
  };

  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getResolutions(null, () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, []);

  // Define table columns
  const columns = [
    "Name",
    "Role",
    "Created At",
    "Description",
    "Updated At",
    "Status",
  ];

  // Define the mapping from column name to data property
  const keyMap = {
    Name: "name",
    Role: "opendBy",
    "Created At": "createdAtFormatted",
    Description: "descriptionTruncated",
    "Updated At": "updatedAtFormatted",
    Status: "statusBadge",
  };

  // Process the data to include formatted fields
  const tableData = resolutions?.map((data, index) => {
    return {
      ...data,
      createdAtFormatted: moment
        .unix(data?.createdAt?.seconds)
        .format("MMMM Do YYYY, h:mm:ss"),
      updatedAtFormatted: moment
        .unix(data?.updatedAt?.seconds)
        .format("MMMM Do YYYY, h:mm:ss"),
      descriptionTruncated: (
        <Button
          onClick={() => setSelectedResolution(data)}
          className="px-3 py-2 border-0"
          id={`PopoverLegacy-${index}`}
          type="button"
        >
          {data?.description ? truncateText(data?.description, 30) : "N/A"}
        </Button>
      ),
      statusBadge: (
        <Badge color={data?.status === "accepted" ? "success" : "danger"} pill>
          {data?.status || "N/A"}
        </Badge>
      ),
      index,
    };
  });

  // Render actions column
  const renderActions = (row) => {
    return (
      <Link to={`resolution-chat/${row?.id}`}>
        <Button color="primary" className="text-sl px-3 py-2">
          View
        </Button>
      </Link>
    );
  };

  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>

        <Card className="p-2">
          <Row>
            <Col sm="12">
              {loader.data && (
                <div className="d-flex align-items-center justify-content-center spinner-container width-100% mb-5">
                  <Spinner color="primary" />
                </div>
              )}
              {!loader.data && (
                <>
                  <TableComponent
                    columns={columns}
                    data={tableData}
                    keyMap={keyMap}
                    renderActions={renderActions}
                  />

                  {resolutions?.length > 4 && (
                    <div className="text-center py-4">
                      <Button
                        onClick={handleLoadMore}
                        disabled={isFetchingResolutions || !hasMoreResolutions}
                        color="primary"
                      >
                        {isFetchingResolutions ? (
                          <Spinner size="sm" />
                        ) : (
                          "Load More"
                        )}
                      </Button>
                    </div>
                  )}

                  {resolutions?.length > 0 &&
                    resolutions.map((_, index) => (
                      <UncontrolledPopover
                        placement="top"
                        target={`PopoverLegacy-${index}`}
                        trigger="legacy"
                      >
                        <PopoverBody>
                          {selectedResolution?.description || "N/A"}
                        </PopoverBody>
                      </UncontrolledPopover>
                    ))}
                </>
              )}
            </Col>
          </Row>
        </Card>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
    </>
  );
};

export default Resolution;
